import React, { useEffect, useState } from "react";
import styles from "./Role.module.css";
import {
  createRole,
  getCustomerRoles,
  getFeatureforRole,
  getnewFeatureList,
  updateRole,
} from "../../api";
import Tab from "../../Common/Tab/Tab";
import { Col, Row, Spinner } from "react-bootstrap";
import Button from "../../Common/Button";
import FeatureAccess from "./featureAcess";
import { Input } from "../../Common";
import {DropDown} from "../../Common";
import withFeatureActions from "../../withFeatureActions";

const AddRole = ({ featureAccess }) => {
  const { readAccess, writeAccess, modifyAccess } = featureAccess ;
  const [key, setKey] = useState("Create Role");
  const [roleName, setRoleName] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [roleId, setRoleId] = useState(null);
  const [role, setRole] = useState("");
  const [message, setMessage] = useState("");
  const [roleErrorMessage, setRoleErrorMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [featureList, setFeatureList] = useState([]);
  const [accessState, setAccessState] = useState({});
  const [forceReset, setForceReset] = useState(0); // Add this to force re-initialization

  const keys = [];
    if (writeAccess) keys.push("Create Role");
    if (modifyAccess) keys.push("Edit Role");

  useEffect(() => {
    fetchRoles();
    fetchNewFeatureList();
  }, []);

  useEffect(() => {
    if (isEditMode && role && roleId) {
      fetchRoleFeatureAccess(roleId);
    } else if (!isEditMode) {
      const initialState = initializeAccessState(featureList);
      setAccessState(initialState);
      setForceReset(prev => prev + 1);
    } else if (isEditMode && !role) {
      const initialState = initializeAccessState(featureList);
      setAccessState(initialState);
      setForceReset(prev => prev + 1);
    }
  }, [role, isEditMode, featureList]);

  useEffect(() => {
    setMessage("");
    setErrorMessage("");
    setRoleErrorMessage("");
    if (key === "Edit Role") {
      setIsEditMode(true);
      setRoleErrorMessage("");
      const initialState = initializeAccessState(featureList);
      setAccessState(initialState);
      setForceReset(prev => prev + 1);
    } else {
      setIsEditMode(false);
      clearForm();
    }
  }, [key]);

  const fetchRoles = async () => {
    try {
      const resp = await getCustomerRoles();
      if (resp.data.code === 200) {
        let result = [];
        let list = Object.entries(resp.data.data.data);
        list.map((x) =>
          x[1][0].role_title == null ? "" : result.push(x[1][0])
        );
        setRoleList(result);
      }
    } catch (error) {
      setErrorMessage("Error fetching roles:", error);
    }
  };

  const fetchNewFeatureList = async () => {
    setLoading(true);
    try {
      const res = await getnewFeatureList();
      if (res?.data?.code === 200) {
        setFeatureList(res.data.data);
      } else {
        setErrorMessage("Error loading features");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchRoleFeatureAccess = async (id) => {
    try {
      const resp = await getFeatureforRole(id);
      if (resp?.status === 200 && resp?.data?.data?.features) {
        const roleFeatures = resp.data.data.features;

        const defaultState = {};
        featureList.forEach(({ source, featureList: parents }) => {
          defaultState[source] = {};
          parents.forEach((parent) => {
            defaultState[source][parent.parentFeature] = {
              actions: { read: false, write: false, modify: false },
              children: {},
            };
            parent.subFeatures.forEach((sub) => {
              defaultState[source][parent.parentFeature].children[
                sub.componentName
              ] = {
                read: false,
                write: false,
                modify: false,
              };
            });
          });
        });

        roleFeatures.forEach((featureBlock) => {
          const source = featureBlock.source;
          featureBlock.featureList.forEach((parent) => {
            const parentKey = parent.componentName;
            if (defaultState[source]?.[parentKey]) {
              defaultState[source][parentKey].actions = {
                read: parent.readAccess || false,
                write: parent.writeAccess || false,
                modify: parent.modifyAccess || false,
              };

              if (Array.isArray(parent.subFeatures)) {
                parent.subFeatures.forEach((sub) => {
                  if (
                    defaultState[source][parentKey].children[sub.componentName]
                  ) {
                    defaultState[source][parentKey].children[
                      sub.componentName
                    ] = {
                      read: sub.readAccess || false,
                      write: sub.writeAccess || false,
                      modify: sub.modifyAccess || false,
                    };
                  }
                });
              }
            }
          });
        });
        setAccessState(defaultState);
      }
    } catch (error) {
      setErrorMessage("Error fetching role features:", error);
    }
  };

  const flattenAccess = (accessState, featureList) => {
    const result = [];

    try {
      if (!featureList || !Array.isArray(featureList)) {
        return result;
      }

      featureList.forEach(({ source, featureList: parents }) => {
        if (!parents || !Array.isArray(parents)) {
          return;
        }

        parents.forEach((parent) => {
          const parentAccess = accessState?.[source]?.[parent.parentFeature];

          if (parentAccess && parentAccess.actions) {
            const parentFeatureId = parent.parentFeatureId || parent.dashboardFeatureId;
            
            const parentFeature = {
              featureId: parseInt(parentFeatureId),
              isRead: !!parentAccess.actions.read,
              isWrite: !!parentAccess.actions.write,
              isModify: !!parentAccess.actions.modify,
            };

            if (
              parentFeature.isRead ||
              parentFeature.isWrite ||
              parentFeature.isModify
            ) {
              result.push(parentFeature);
            }

            if (parent.subFeatures && Array.isArray(parent.subFeatures)) {
              parent.subFeatures.forEach((sub) => {
                const subAccess =
                  parentAccess.children?.[sub.componentName] || {};
                const subFeature = {
                  featureId: parseInt(sub.dashboardFeatureId),
                  isRead: !!subAccess.read,
                  isWrite: !!subAccess.write,
                  isModify: !!subAccess.modify,
                };

                if (
                  subFeature.isRead ||
                  subFeature.isWrite ||
                  subFeature.isModify
                ) {
                  result.push(subFeature);
                }
              });
            }
          }
        });
      });
    } catch (error) {
      setErrorMessage("Error flattening access:", error);
    }

    return result;
  };

  const initializeAccessState = (features) => {
    const initial = {};
    if (!features || !Array.isArray(features)) return initial;
    features.forEach(({ source, featureList }) => {
      initial[source] = {};
      featureList.forEach((parent) => {
        initial[source][parent.parentFeature] = {
          actions: { read: false, write: false, modify: false },
          children: {},
        };
        parent.subFeatures.forEach((sub) => {
          initial[source][parent.parentFeature].children[sub.componentName] = {
            read: false,
            write: false,
            modify: false,
          };
        });
      });
    });
    return initial;
  };

  const clearForm = () => {
    setRole("");
    setRoleName("");
    setErrorMessage("");
    setRoleErrorMessage("");
    const initialState = initializeAccessState(featureList);
    setAccessState(initialState);
    setForceReset(prev => prev + 1);
  };

  const callCreateOrUpdateFunction = async () => {
    try {
      setLoader(true);

      const existing = roleList?.find(
        (role) =>
          role?.role_title?.toUpperCase?.() === roleName?.toUpperCase?.()
      );

      if (!isEditMode && existing) {
        setErrorMessage("Role name already exists!");
        setLoader(false);
        return;
      }

      const featuresArray = flattenAccess(accessState, featureList);

      if (!Array.isArray(featuresArray) || featuresArray.length === 0) {
        setErrorMessage("Please select at least one feature");
        setLoader(false);
        return;
      }

      const payload = {
        roleName: isEditMode ? role || "" : roleName || "",
        features: featuresArray,
      };

      if (isEditMode && roleId) {
        payload.roleId = roleId;
      }

      const resp = isEditMode
        ? await updateRole(payload)
        : await createRole(payload);

      const responseCode = resp?.data?.code || resp?.data?.data?.code;
      if (responseCode === 200) {
        setMessage(resp?.data?.data);
        fetchRoles();
        clearForm();
        setTimeout(() => {
          setMessage("");
        }, 3000);
      } else {
        setErrorMessage(resp?.data?.message || "Something went wrong");
      }
    } catch (err) {
      setErrorMessage(
        err?.response?.data?.message || err?.message || "Something went wrong"
      );
    } finally {
      setLoader(false);
    }
  };

  const handleCreateOrUpdateRole = () => {
    setMessage("");
    setErrorMessage("");
    setRoleErrorMessage("");

    if (!isEditMode && (!roleName || roleName.trim() === "")) {
      setRoleErrorMessage("Please enter role name");
      return;
    }

    if (isEditMode && (!role || !roleId)) {
      setRoleErrorMessage("Please select a role");
      return;
    }

    const selectedFeatures = flattenAccess(accessState, featureList);
    if (selectedFeatures.length === 0) {
      setErrorMessage("Please select at least one feature");
      return;
    }

    callCreateOrUpdateFunction();
  };

  if (!writeAccess && !modifyAccess) {
    return (
      <div className={styles.noAccessMessage}>
        You do not have access to create or edit roles.
      </div>
    );
  }
  return (
    <div className={styles.containerCardRoles}>
      <div className={styles.createRoleCard}>
        <div className={styles.tabs}>
          <Tab
            keys={keys}
            activeKey={key}
            onSelect={setKey}
            classes={styles.tabWidth}
          />
        </div>
        <hr className={styles.separator} />
        <div className={styles.card}>
          <Row style={{ marginBottom: "20px" }}>
            <Col md={3} className={styles.inputDiv}>
              Role Name
            </Col>
            <Col md={9}>
              {key === "Edit Role" ? (
                <div>
                  <DropDown
                    name="role"
                    value={role}
                    data={roleList.map((item) => ({
                      label: item.role_title,
                      value: item.role_title,
                      roleId: item.dashboard_role_id,
                    }))}
                    placeholder="Select Role"
                    required={true}
                    onChange={(val) => {
                      const selected = roleList.find((r) => r.role_title === val);
                      setRole(val);
                      setRoleId(selected?.dashboard_role_id);
                      setErrorMessage("");
                      setRoleErrorMessage("");
                    }}
                    error={!!roleErrorMessage}
                    helperText={roleErrorMessage}
                  />
                </div>
              ) : (
                <Input
                  placeholder="Enter Name"
                  type="text"
                  name="RoleName"
                  value={roleName}
                  onChange={(e) => {
                    setRoleName(e.target.value);
                    setErrorMessage("");
                    setRoleErrorMessage("");
                  }}                  
                  required={true}
                  error={!!roleErrorMessage}
                  helperText={roleErrorMessage}
                />
              )}
            </Col>
          </Row>

          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Spinner animation="border" className={styles.spinnerColor} />
            </div>
          ) : (
            <>
              <FeatureAccess
                key={forceReset}
                data={featureList}
                accessState={accessState}
                setAccessState={setAccessState}
                isEditMode={isEditMode}
              />
              <div style={{ marginTop: "40px"}}>
                {message && (
                  <div className={styles.successMessage}>{message}</div>
                )}
                {errorMessage && (
                  <div className={styles.errorMessage}>{errorMessage}</div>
                )}
                <div className={styles.submitButton}>
                <Button
                  onClick={handleCreateOrUpdateRole}
                  title={isEditMode ? "Update Role" : "Create Role"}
                  place="center"
                  loading={loader}
                />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default withFeatureActions(AddRole, "ADMIN", "Add Role");